import { useMemo, useState } from 'react';
import { mockAPISources } from '@/lib/mockData';
import { beginnerTutorials } from '@/lib/tutorialData';
import { APISource, Dataset, ResearchDomainTemplate } from '@/lib/types';

export function useAppState() {
  // State management
  const [selectedDatasets, setSelectedDatasets] = useState<Dataset[]>([]);
  const [activeTab, setActiveTab] = useState('templates');
  const [selectedSource, setSelectedSource] = useState<APISource | null>(null);
  const [previewDataset, setPreviewDataset] = useState<Dataset | null>(null);
  const [qualityReports, setQualityReports] = useState<Record<string, any>>({});
  const [correlations, setCorrelations] = useState<any[]>([]);
  const [filteredSources, setFilteredSources] =
    useState<APISource[]>(mockAPISources);
  const [appliedTemplate, setAppliedTemplate] =
    useState<ResearchDomainTemplate | null>(null);
  const [activeTutorial, setActiveTutorial] = useState<any>(null);
  const [showKeyboardHelp, setShowKeyboardHelp] = useState(false);
  const [selectedPanelExpanded, setSelectedPanelExpanded] = useState(false);

  // Computed values
  const allDatasets = useMemo(
    () => mockAPISources.flatMap(source => source.datasets),
    []
  );
  const totalDatasetCount = allDatasets.length;
  const hasVisualizations = false; // Placeholder
  const hasExports = false; // Placeholder
  const isLoading = false; // Placeholder

  return {
    // State
    selectedDatasets,
    setSelectedDatasets,
    activeTab,
    setActiveTab,
    selectedSource,
    setSelectedSource,
    previewDataset,
    setPreviewDataset,
    qualityReports,
    setQualityReports,
    correlations,
    setCorrelations,
    filteredSources,
    setFilteredSources,
    appliedTemplate,
    setAppliedTemplate,
    activeTutorial,
    setActiveTutorial,
    showKeyboardHelp,
    setShowKeyboardHelp,
    selectedPanelExpanded,
    setSelectedPanelExpanded,

    // Computed values
    allDatasets,
    totalDatasetCount,
    hasVisualizations,
    hasExports,
    isLoading,

    // Constants
    tutorialsWithCallbacks: beginnerTutorials,
  };
}
